import React from 'react';

import { Container } from './styles';

function Skeleton({ marginUpDown, marginSides, width, height, marginBottom }) {
  return (
    <Container
      marginUpDown={marginUpDown}
      marginSides={marginSides}
      width={width}
      height={height}
      marginBottom={marginBottom}
      name="skeleton-component"
    />
  );
}

export default Skeleton;
